import {AttributePropertiesPlugin} from "./AttributePropertiesPlugin";


export class AttributePropertiesPluginRegistry {
    private readonly plugins: Map<string, AttributePropertiesPlugin> = new Map();

    registerPlugin(plugin: AttributePropertiesPlugin): void {
        const supportedCoreDataType = plugin.getSupportedCoreDataType();
        if (this.plugins.has(supportedCoreDataType)) {
            throw new Error(`Renderer plugin for core data type ${supportedCoreDataType} already registered`);
        }
        this.plugins.set(supportedCoreDataType, plugin);
    }

    getPlugin(coreDataType: string): AttributePropertiesPlugin | undefined {
        return this.plugins.get(coreDataType);
    }

    getAvailablePlugins(): AttributePropertiesPlugin[] {
        return Array.from(this.plugins.values());
    }
}
